import React from "react";
import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {whyUsInfoData} from "../constants/why_us_info_data";

export const ForYouWhyUs = () => {
    return (
        <Container as="section" className={whyUsSectionStyle}>
            <Text variant="headline_1" as="h3" align="center" mb={4}>
                Dlaczego warto nam zaufać?
            </Text>

            <div className={infoWrapper}>
                {whyUsInfoData.map((data) => (
                    <div key={data.title} className={infoHolder}>
                        {data.icon?.({
                            wrapperColor: getThemeVariable("colors.primary"),
                            wrapperSize: "9.6",
                            size: "9.6"
                        }) || null}

                        <div className={textHolder}>
                            <Text variant={data.titleVariant} align="center">
                                {data.title}
                            </Text>
                            <Text variant={data.copyVariant} align="center">
                                {data.copy}
                            </Text>
                        </div>
                    </div>
                ))}
            </div>
        </Container>
    );
};

const flexColumnCenterRaw = css.raw({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
});

const whyUsSectionStyle = css({
    marginTop: "9.6rem",
    marginBottom: 8
});

const infoWrapper = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "space-between",

    md: {
        flexDirection: "row"
    }
});

const infoHolder = css({
    ...flexColumnCenterRaw,
    justifyContent: "space-between",
    padding: 3,
    gap: 2
});

const textHolder = css({
    ...flexColumnCenterRaw,
    gap: 2
});
import React from "react";
import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {whyUsInfoData} from "../constants/why_us_info_data";

export const ForYouWhyUs = () => {
    return (
        <Container as="section" className={whyUsSectionStyle}>
            <Text variant="headline_1" as="h3" align="center" mb={4}>
                Dlaczego warto nam zaufać?
            </Text>

            <div className={infoWrapper}>
                {whyUsInfoData.map((data) => (
                    <div key={data.title} className={infoHolder}>
                        {data.icon?.({
                            wrapperColor: getThemeVariable("colors.primary"),
                            wrapperSize: "9.6",
                            size: "9.6"
                        }) || null}

                        <div className={textHolder}>
                            <Text variant={data.titleVariant} align="center">
                                {data.title}
                            </Text>
                            <Text variant={data.copyVariant} align="center">
                                {data.copy}
                            </Text>
                        </div>
                    </div>
                ))}
            </div>
        </Container>
    );
};

const flexColumnCenterRaw = css.raw({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
});

const whyUsSectionStyle = css({
    marginTop: "9.6rem",
    marginBottom: 8
});

const infoWrapper = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "space-between",

    md: {
        flexDirection: "row"
    }
});

const infoHolder = css({
    ...flexColumnCenterRaw,
    justifyContent: "space-between",
    padding: 3,
    gap: 2
});

const textHolder = css({
    ...flexColumnCenterRaw,
    gap: 2
});
